

export default {
	
	oneTimeCosts: [
		{
			id: 0,
			titleText: 'Программный комплекс АРКУС, в т.ч.',
			title: true,
			price: 20000,
			sum: 0,
			active: false,
			subCat: [
				{
					id: 1,
					titleText: 'Установка и внедрение на компьютеры компании',
					title: false,
					price: 20000,
					sum: 0,
					active: true,
					input: false,
					inputCalc: 1,
					disabled: true,
					helpText: 'Программа для автоматизации управления и учета управляющих компаний и ТСЖ',
					show: true,
				},
				{
					id: 2,
					titleText: 'Конвертация данных из предыдущей программы (кол. месяцев)',
					title: false,
					price: 13000,
					sum: 0,
					active: true,
					inputCalc: 12,
					input: true,
					indFormula: '7000 + (item.inputCalc * 500)',
					helpText: 'Перенесем данные между периодами печати квитанций - от 2 дней до 2 недель',
					show: true,
				},
			]
		},
		{
			id: 3,
			titleText: 'Требования законодательства, в т.ч.',
			title: true,
			price: 20000,
			sum: 0,
			active: false,
			subCat: [
				{
					id: 4,
					titleText: 'Фискальный накопитель',
					title: false,
					price: 15600,
					sum: 0,
					active: true,
					input: false,
					inputCalc: 1,
					helpText: 'Шифровальное средство, в памяти которого хранится информация обо всех сформированных чеках',
					show: true,
				},
/* 				{
					id: 5,
					titleText: 'АРКУС: Диспетчеризация',
					title: false,
					price: 6000,
					sum: 0,
					active: false,
					inputCalc: 1,
					input: false,
					helpText: 'Решение для организации рабочего место диспетчера'
				}, */
			]
		},
		{
			id: 6,
			titleText: 'Бухгалтерский учет, в т.ч.',
			title: true,
			price: 10300,
			sum: 0,
			active: false,
			subCat: [
				{
					id: 9,
					titleText: 'Сервис 1С-Отчетность (лицензия на 1 год)',
					title: false,
					price: 5900,
					sum: 0,
					active: true,
					inputCalc: 1,
					input: false,
					helpText: 'Сервис для отправки электронной отчетности во все контролирующие органы прямо из программы «1С: Предприятие 8»',
					show: true
				},
				{
					id: 7,
					titleText: '1С: Бухгалтерия',
					title: false,
					price: 5400,
					sum: 0,
					active: true,
					input: false,
					inputCalc: 1,
					activeSelect: 0,
					select: true,
					helpText: 'Базовую версию рекомендуем небольшим организациям, версию «ПРОФ» — тем, кому нужен многопользовательский режим или ведение нескольких организаций в одной информационной базе',
					show: true,
					selectItems: [
						{
							value: 0,
							title: '"1С: Бухгалтерия 8.3 Базовая версия"',
							price: 5400
						},
						{
							value: 1,
							title: '"1С: Бухгалтерия 8.3 ПРОФ"',
							price: 13000
						},
					]
				},
				/* {
					id: 8,
					titleText: '"1С: Зарплата и управление персоналом"',
					title: false,
					price: 8100,
					sum: 0,
					active: true,
					input: false,
					inputCalc: 1,
					activeSelect: 0,
					select: true,
					helpText: 'Базовую версию рекомендуем небольшим организациям, версию «ПРОФ» — тем, кому нужен многопользовательский режим или ведение нескольких организаций в одной информационной базе',
					selectItems: [
						{
							value: 0,
							title: '"1С: Зарплата и управление персоналом 8. Базовая версия"',
							price: 8100
						},
						{
							value: 1,
							title: '"1С: Зарплата и управление персоналом 8. ПРОФ"',
							price: 22600
						},
					]
				}, */
				
				{
					id: 10,
					titleText: 'Дополнительное рабочее место',
					title: false,
					price: 6300,
					sum: 0,
					active: false,
					inputCalc: 1,
					input: true,
					indFormula: 'item.inputCalc * 6300',
					helpText: 'Приобретение дополнительных рабочих мест возможно только для «ПРОФ» версии программы.',
					show: false
				},
			]
		},
		/* {
			id: 10,
			titleText: 'Безопасность данных, в т.ч.',
			title: true,
			price: 1320,
			onePrice: 1320,
			sum: 0,
			active: false,
			subCat: [
				{
					id: 11,
					titleText: '"Kaspersky Anti-Virus" (лицензия на 1 год) (кол. компьютеров)',
					title: false,
					price: 1320,
					sum: 0,
					active: true,
					input: true,
					helpText: 'Самый популярный антивирус.',
					indFormula: 'Math.ceil(item.inputCalc / 2) * 1320',
					inputCalc: 1
				},
			]
		}, */

	],
	monthlyCosts: [
		{
			id: 12,
			titleText: 'Программный комплекс АРКУС, в т.ч.',
			title: true,
			price: 1500,
			sum: 0,
			active: false,
			subCat: [
				{
					id: 13,
					titleText: 'Техническая поддержка ПК АРКУС',
					title: false,
					price: 1500,
					sum: 0,
					active: true,
					input: false,
					disabled: true,
					helpText: 'Регулярные обновления программы, консультации по сложным вопросам из сферы ЖКХ и много другое',
					inputCalc: 1,
					activeSelect: 0,
					select: true,
					selectItems: [
						{
							value: 0,
							title: 'Техническая поддержка ПК АРКУС. Базовая версия',
							price: 1500
						},
						{
							value: 1,
							title: 'Техническая поддержка ПК АРКУС. ПРОФ',
							price: 3000
						},
					]
				},
			]
		},
		{
			id: 14,
			titleText: 'Требования законодательства, в т.ч.',
			title: true,
			price: 2400,
			sum: 0,
			active: false,
			subCat: [
				{
					id: 15,
					titleText: 'Размещение информации в ГИС ЖКХ',
					title: false,
					price: 2000,
					sum: 0,
					active: true,
					input: false,
					inputCalc: 1,
					helpText: 'Разместим за вас ту информацию, которую вы не заносите в «АРКУС»: акты выполненных работ, договоры оказания услуг, протоколы общих собраний и т. д.'
				},
				{
					id: 16,
					titleText: 'Сайт для управляющей компании',
					title: false,
					price: 700,
					sum: 0,
					active: true,
					input: false,
					inputCalc: 1,
					helpText: 'Удобный сайт с дополнительными функциями'
				},
				{
					id: 17,
					titleText: 'Взаимодействие с онлайн-кассой',
					title: false,
					price: 2000,
					sum: 0,
					active: true,
					input: false,
					inputCalc: 1,
					helpText: 'Аренда онлайн-кассы у нас позволит использовать сервис-посредник, сохраняющий информацию обо всех чеках на случай форс-мажора'
				},
/* 				{
					id: 18,
					titleText: 'АРКУС: Диспетчеризация',
					title: false,
					price: 2000,
					sum: 0,
					active: true,
					input: false,
					inputCalc: 1,
					disabled: true,
					helpText: 'Решение для организации рабочего место диспетчера'
				}, */
			]
		},
		{
			id: 19,
			titleText: 'Безопасность данных, в т.ч.',
			title: true,
			price: 150,
			sum: 0,
			active: false,
			subCat: [
				{
					id: 20,
					titleText: 'Резервное копирование базы данных 1С ( шт.)',
					title: false,
					price: 150,
					sum: 0,
					active: true,
					input: true,
					inputCalc: 1,
					indFormula: 'item.inputCalc * 150',
					helpText: 'Надежная защита от потери информации в случае технических сбоев вашего компьютера, на котором установлены базы данных. '
				},
			]
		},
		{
			id: 21,
			titleText: 'Техническая помощь, в т.ч.',
			title: true,
			price: 150,
			sum: 0,
			active: false,
			subCat: [
				{
					id: 22,
					titleText: 'Обслуживание компьютерной техники',
					title: false,
					price: 150,
					sum: 0,
					active: false,
					input: true,
					inputCalc: 1,
					indFormula: '(item.inputCalc * 700) < 4200 ? 4200 : item.inputCalc * 700',
					helpText: 'Полный комплекс профилактических работ, установка программного обеспечения, помощь в выборе компьютерной техники и много другое'
				},
			]
		},
	]
}